import axios from 'axios'

export const saveSessionStationObservations = async (observations) => {
  try {
    return (await axios.post(`/sessions/station-observation`, { observations })).data
  } catch (e) {
    return true
  }
}
